import { Box, Link, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import FlexContainer from '../../../../../components/material-ui/adaptive/FlexContainer';
import CusInput from '../../../../../components/material-ui/CusInput';
import CusButton from '../../../../../components/material-ui/CusButton';
import { useAppSelector } from '../../../../../store';
import CasinoBtnSave from '../../../../../components/casino/CasinoBtnSave';
import { ENUM_CASINO_LIMIT } from '../../../../../enums/enums';
import { API_CASINO } from '../../../../../api/casino';
import useNumberParams from '../../../../../hooks/useNumberParams';
import useToast from '../../../../../hooks/useToast';
import TypographyText from '../../../../../components/material-ui/table/TypographyText';

export default function WithdrawContent() {
  const { t } = useTranslation();
  const { successToast } = useToast();
  const casinoId = useNumberParams('casinoId');
  const currenciesInfo = useAppSelector((state) => state.user.info.currency);
  const currencies = Object.keys(currenciesInfo);
  const [currencyInfo, setCurrencyInfo] = useState({});

  const limitType = ENUM_CASINO_LIMIT.output;

  const onSetDefault = () => {
    setCurrencyInfo({
      RUB: { min: 3000, max: 100_000 },
      EUR: { min: 10, max: 500 },
      KZT: { min: 5000, max: 300000 },
      KGS: { min: 800, max: 50000 },
      UZS: { min: 30000, max: 5000000 },
      AZN: { min: 25, max: 2500 },
      ARS: { min: 2000, max: 300_000 },
      BRL: { min: 20, max: 10000 },
      USDT: { min: 5, max: 5000 }
    });
  };

  const onSaveClick = () => {
    console.log('currencyInfo', currencyInfo);
    API_CASINO.limit
      .set({ casinoId, type: limitType, data: currencyInfo })
      .then((e) => {
        successToast('Information updated successfully');
      })
      .catch(console.error);
  };

  useEffect(() => {
    API_CASINO.limit
      .get({ casinoId, type: limitType })
      .then((e) => {
        const data = e.data.data || {};
        if (data && Object.keys(data).length) setCurrencyInfo(data);
      })
      .catch(console.error);
  }, [casinoId]);
  return (
    <Stack gap={2}>
      <Box component={'span'}>
        <Typography component={'span'}>
          {t('Minimum and maximum amounts for one payment request.')}
        </Typography>{' '}
        <Link component={TypographyText} sx={{ cursor: 'pointer' }} onClick={onSetDefault}>
          {t('Use default values')}
        </Link>
      </Box>

      <Stack gap={1}>
        {currencies.map((currency) => (
          <FlexContainer key={currency} gap={4}>
            <Stack direction={'row'} alignItems={'center'} gap={0.5}>
              <CusInput
                isVerySmall
                isRow
                label={'Minimum'}
                type="number"
                value={currencyInfo[currency]?.min}
                inputProps={{ min: 1 }}
                onChange={(e) => {
                  const value = e.target.value;
                  setCurrencyInfo((prev) => {
                    const prevInfo = JSON.parse(JSON.stringify(prev));
                    if (!prevInfo[currency]) prevInfo[currency] = {};
                    prevInfo[currency].min = +value || value;
                    return prevInfo;
                  });
                }}
              />
              <Typography fontSize={12} color="textSecondary">
                {currency}
              </Typography>
            </Stack>{' '}
            <Stack direction={'row'} alignItems={'center'} gap={0.5} pl={currency.length == 3}>
              <CusInput
                isVerySmall
                isRow
                label={'Maximum'}
                type="number"
                value={currencyInfo[currency]?.max}
                inputProps={{ min: 1 }}
                onChange={(e) => {
                  const value = e.target.value;
                  setCurrencyInfo((prev) => {
                    const prevInfo = JSON.parse(JSON.stringify(prev));
                    if (!prevInfo[currency]) prevInfo[currency] = {};
                    prevInfo[currency].max = +value || value;
                    return prevInfo;
                  });
                }}
              />
              <Typography fontSize={12} color="textSecondary">
                {currency}
              </Typography>
            </Stack>
          </FlexContainer>
        ))}
      </Stack>
      <CasinoBtnSave onClick={onSaveClick} />
    </Stack>
  );
}
